import React from "react";
import { TooltipContainer } from "../../../styled/setting";

const Tooltip = ({ label = "", tooltip }) => {
  if (!tooltip || !tooltip?.length) return null;
  return (
    <TooltipContainer className="tit">
      {label}
      <span>?</span>
      <div className="tooltip-box">
        {tooltip.map((tip, index) => (
          <div key={index}>
            {tip?.title && <strong>{tip.title}</strong>}
            {tip?.description && <p>{tip.description}</p>}
            {tip?.example && <p>{tip.example}</p>}
          </div>
        ))}
      </div>
    </TooltipContainer>
  );
};

export default Tooltip;
